import { defineStore } from 'pinia';
import {
  GetReferenceBookTermSearchResponse,
  GetReferencesArticlesResponse,
  ReferencesBook,
  trucodeReferenceService
} from 'src/services/TrucodeReferencesService';
import { ref } from 'vue';

export const useTrucodeReferenceStore = defineStore('trucodereferencestore', () => {

  const bookReferences = ref<ReferencesBook[] | undefined>(undefined);
  const bookReferenceYearsMap = ref<Map<string, number[] | undefined> | undefined>(undefined);
  const bookReferenceYearIssueMap = ref<Map<[string, number], ReferencesBook[] | undefined> | undefined>(undefined);
  const referencesArticlesResponseMap = ref<Map<number, GetReferencesArticlesResponse | undefined> | undefined>(undefined);
  const referenceBookTermSearchMap = ref<Map<[string, string], GetReferenceBookTermSearchResponse | undefined> | undefined>(undefined);
  async function getBookReference():  Promise<ReferencesBook[] | undefined> {
    if (!bookReferences.value) {
      bookReferences.value = await trucodeReferenceService.getBookReference();
    }

    return bookReferences.value;
  }

  async function getBookReferenceYears(book: string):  Promise<number[] | undefined> {
    if(!bookReferenceYearsMap.value) {
      bookReferenceYearsMap.value = new Map<string, number[]>();
    }

    let result = bookReferenceYearsMap.value.get(book);

    if (!result) {
      result = await trucodeReferenceService.getBookReferenceYears(book);
      bookReferenceYearsMap.value.set(book, result);
    }

    return result;
  }

  async function getBookReferenceYearIssue(book: string, year: number):  Promise<ReferencesBook[] | undefined> {
    if (!bookReferenceYearIssueMap.value) {
      bookReferenceYearIssueMap.value = new Map<[string, number], ReferencesBook[] | undefined>();
    }

    let result = bookReferenceYearIssueMap.value.get([book, year]);

    if (!result) {
      result = await trucodeReferenceService.getBookReferenceYearIssue(book, year);
      bookReferenceYearIssueMap.value.set([book, year], result);
    }

    return result;
  }

  async function getReferencesArticle(articleId: string):  Promise<HTMLElement | undefined> {
    return await trucodeReferenceService.getReferencesArticle(articleId);
  }

  async function getReferencesArticles(issueId: number):  Promise<GetReferencesArticlesResponse | undefined> {
    if(!referencesArticlesResponseMap.value) {
      referencesArticlesResponseMap.value = new Map<number, GetReferencesArticlesResponse>();
    }

    let result = referencesArticlesResponseMap.value.get(issueId);

    if (!result) {
      result = await trucodeReferenceService.getReferencesArticles(issueId);
      referencesArticlesResponseMap.value.set(issueId, result);
    }

    return result;
  }

  async function getReferenceBookTermSearch(book: string, term: string): Promise<GetReferenceBookTermSearchResponse | undefined> {
    if (!referenceBookTermSearchMap.value) {
      referenceBookTermSearchMap.value = new Map<[string, string], GetReferenceBookTermSearchResponse | undefined>();
    }

    let result = referenceBookTermSearchMap.value.get([book, term]);

    if (!result) {
      result = await trucodeReferenceService.getReferenceBookTermSearch(book, term);
      referenceBookTermSearchMap.value.set([book, term], result);
    }

    return result;
  }

  function getSearchOptions(): ReferencesBook[] {
    return trucodeReferenceService.getSearchOptions();
  }

  function getBrowseOptions(): ReferencesBook[] {
    return trucodeReferenceService.getBrowseOptions();
  }

  return {
    getBookReference,
    getBookReferenceYears,
    getBookReferenceYearIssue,
    getReferencesArticle,
    getReferencesArticles,
    getReferenceBookTermSearch,
    getSearchOptions,
    getBrowseOptions
  }
})
